import { createContext, useContext, type ReactNode } from 'react';
import type { Ports } from '@buildmate/core';

const PortsContext = createContext<Ports | null>(null);

export function PortsProvider({ ports, children }: { ports: Ports; children: ReactNode }) {
  return <PortsContext.Provider value={ports}>{children}</PortsContext.Provider>;
}

/** Feature code reaches data only through this, never through an adapter. */
export function usePorts(): Ports {
  const ports = useContext(PortsContext);
  if (!ports) throw new Error('usePorts must be used inside a PortsProvider');
  return ports;
}
